// Mind2Magic CRM — Hitos Modal & Form Analytics Module
// Extracted from index.html Step 12.

import {
    STAGES,
    EMPRESAS_STAGES,
    TYPE_LABELS,
    FORM_TRIP_LABELS,
    FORM_DEST_MAP,
    FORM_STEP_PHASES,
    defaultSettings
} from './constants.js'
import { store } from './store.js'
import { sb } from './supabase/client.js'

// Module-scoped mutable variables
let _hitosFilterTipo = 'todos'
let _hitosFilterPeriodo = '14'
let _activePopoverBtn = null

// ========== HITOS MODAL ==========

function openHitosModal() {
    const hitos = window._allHitos || []
    if (!hitos.length) { window.showToast('Sin hitos próximos', 'info'); return }
    // Build type options from actual data
    const tipos = new Set(hitos.map(h => h.tipo))
    let tipoOpts = '<option value="todos">Todos</option>'
    const tipoLabels = { disney: 'Disney', crucero: 'Crucero', disney_cruise: 'Crucero Disney', universal: 'Universal', hotel: 'Hotel', pago: 'Pagos', otro: 'Otro' }
    tipos.forEach(t => { tipoOpts += `<option value="${t}" ${_hitosFilterTipo === t ? 'selected' : ''}>${tipoLabels[t] || t}</option>` })

    const overlay = document.createElement('div')
    overlay.id = 'hitosModalOverlay'
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;'
    overlay.onclick = e => { if (e.target === overlay) closeHitosModal() }

    overlay.innerHTML = `
    <div style="background:var(--bg-1);border:1px solid var(--border);border-radius:12px;width:90%;max-width:620px;max-height:80vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.4);">
        <div style="padding:16px 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;font-size:16px;color:var(--text-1);">📅 Todos los Hitos</h3>
            <button onclick="closeHitosModal()" style="background:none;border:none;color:var(--text-3);cursor:pointer;font-size:18px;padding:4px 8px;">&times;</button>
        </div>
        <div style="padding:12px 20px;border-bottom:1px solid var(--border);display:flex;gap:10px;flex-wrap:wrap;align-items:center;">
            <select id="hitosFilterTipo" onchange="_hitosFilterTipo=this.value;renderHitosModalList()" style="padding:6px 10px;border-radius:6px;border:1px solid var(--border);background:var(--bg-2);color:var(--text-1);font-size:12px;">
                ${tipoOpts}
            </select>
            <select id="hitosFilterPeriodo" onchange="_hitosFilterPeriodo=this.value;renderHitosModalList()" style="padding:6px 10px;border-radius:6px;border:1px solid var(--border);background:var(--bg-2);color:var(--text-1);font-size:12px;">
                <option value="7" ${_hitosFilterPeriodo==='7'?'selected':''}>Próximos 7 días</option>
                <option value="14" ${_hitosFilterPeriodo==='14'?'selected':''}>Próximos 14 días</option>
                <option value="30" ${_hitosFilterPeriodo==='30'?'selected':''}>Próximos 30 días</option>
                <option value="60" ${_hitosFilterPeriodo==='60'?'selected':''}>Próximos 60 días</option>
                <option value="90" ${_hitosFilterPeriodo==='90'?'selected':''}>Próximos 90 días</option>
                <option value="all" ${_hitosFilterPeriodo==='all'?'selected':''}>Todos (incl. vencidos)</option>
            </select>
            <span id="hitosModalCount" style="font-size:11px;color:var(--text-3);margin-left:auto;"></span>
        </div>
        <div id="hitosModalList" style="flex:1;overflow-y:auto;padding:8px 12px;"></div>
    </div>`
    document.body.appendChild(overlay)
    renderHitosModalList()
}

function renderHitosModalList() {
    const container = document.getElementById('hitosModalList')
    const countEl = document.getElementById('hitosModalCount')
    if (!container) return
    let hitos = window._allHitos || []

    // Filter by tipo
    if (_hitosFilterTipo !== 'todos') hitos = hitos.filter(h => h.tipo === _hitosFilterTipo)

    // Filter by periodo
    if (_hitosFilterPeriodo !== 'all') {
        const maxDias = parseInt(_hitosFilterPeriodo)
        hitos = hitos.filter(h => h.dias >= -3 && h.dias <= maxDias)
    }

    if (countEl) countEl.textContent = `${hitos.length} hito${hitos.length !== 1 ? 's' : ''}`

    if (!hitos.length) {
        container.innerHTML = '<div style="text-align:center;padding:40px 20px;color:var(--text-3);font-size:13px;">Sin hitos para estos filtros</div>'
        return
    }

    // Group by day label
    let lastGroup = null
    let html = ''
    hitos.forEach(h => {
        const group = h.dias < 0 ? 'Vencidos' : h.dias === 0 ? 'Hoy' : h.dias === 1 ? 'Mañana' : h.dias <= 3 ? 'Próximos 3 días' : h.dias <= 7 ? 'Esta semana' : h.dias <= 14 ? 'Próximas 2 semanas' : h.dias <= 30 ? 'Este mes' : 'Más adelante'
        if (group !== lastGroup) {
            lastGroup = group
            html += `<div style="font-size:10px;font-weight:600;color:var(--text-3);text-transform:uppercase;letter-spacing:0.5px;padding:10px 8px 4px;${group === 'Vencidos' ? 'color:var(--red);' : ''}">${group}</div>`
        }
        const diasLabel = h.dias < 0 ? `${Math.abs(h.dias)}d atrás` : h.dias === 0 ? 'Hoy' : h.dias === 1 ? 'Mañana' : `${h.dias}d`
        const diasColor = h.dias < 0 ? 'var(--red)' : h.dias <= 1 ? 'var(--green)' : h.dias <= 3 ? 'var(--yellow)' : 'var(--text-2)'
        const bgHover = 'onmouseenter="this.style.background=\'var(--bg-2)\'" onmouseleave="this.style.background=\'transparent\'"'
        html += `<div style="display:flex;align-items:center;gap:10px;padding:8px;border-radius:8px;cursor:pointer;transition:background 0.15s;" ${bgHover} onclick="closeHitosModal();openPanel('${h.leadId}')">
            <span style="font-size:16px;width:24px;text-align:center;flex-shrink:0;">${h.icon}</span>
            <div style="flex:1;min-width:0;">
                <div style="font-size:13px;color:var(--text-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${window.escHtml(h.titular || '')}</div>
                <div style="font-size:11px;color:var(--text-3);margin-top:1px;">${window.escHtml(h.hitoNombre || '')}</div>
            </div>
            <span style="font-size:12px;font-weight:600;color:${diasColor};flex-shrink:0;min-width:50px;text-align:right;">${diasLabel}</span>
        </div>`
    })
    container.innerHTML = html
}

function closeHitosModal() {
    const overlay = document.getElementById('hitosModalOverlay')
    if (overlay) overlay.remove()
}

function setDashScope(scope) {
    const { } = store || {}
    store.currentDashScope = scope
    ;['turismo', 'empresas', 'combinado'].forEach(s => {
        document.getElementById('dashScope' + s.charAt(0).toUpperCase() + s.slice(1))?.classList.toggle('active', s === scope)
    })
    document.getElementById('dashTurismoSection').style.display = (scope === 'turismo' || scope === 'combinado') ? '' : 'none'
    document.getElementById('dashEmpresasSection').style.display = (scope === 'empresas' || scope === 'combinado') ? '' : 'none'
    document.getElementById('dashCombinadoSection').style.display = scope === 'combinado' ? '' : 'none'
    // In combinado mode, hide turismo/empresas individual detail grids, show combined summary
    if (scope === 'combinado') {
        document.getElementById('dashTurismoSection').style.display = 'none'
        document.getElementById('dashEmpresasSection').style.display = 'none'
    }
    window.renderDashboard()
}

function renderDashboard() {
    const { leads, historico, clients, settings, currentPeriod, currentDashScope, companyBookings, companies } = store || {}
    let f = leads
    const now = new Date()
    if (currentPeriod === 'semana') f = leads.filter(l => l.travelDate && new Date(l.travelDate) >= new Date(now - 7 * 24 * 60 * 60 * 1000) && new Date(l.travelDate) <= new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000))
    else if (currentPeriod === 'mes') f = leads.filter(l => l.travelDate && new Date(l.travelDate).getMonth() === now.getMonth() && new Date(l.travelDate).getFullYear() === now.getFullYear())
    else if (currentPeriod === 'año') f = leads.filter(l => l.travelDate && new Date(l.travelDate).getFullYear() === now.getFullYear())

    const cierres = f.filter(l => ['pago_completo', 'documentacion', 'en_destino', 'finalizado', 'postventa'].includes(l.stage)).length
    // Exclude cancelado from financials (same filter as pipeline)
    const activeForFinancials = f.filter(l => l.stage !== 'cancelado' && l.stage !== 'no_compro' && !l.wasCanceled)
    const totalVal = activeForFinancials.reduce((s, l) => s + (l.totalVenta || 0), 0)
    const totalComm = activeForFinancials.reduce((s, l) => s + (l.commission || 0), 0)
    const totalM2M = activeForFinancials.reduce((s, l) => s + (l.commission70 || 0), 0)

    // Contar clientes únicos en período
    const uniqueClients = new Set(f.map(l => l.clientKey)).size

    document.getElementById('dashTotalClientes').textContent = uniqueClients
    document.getElementById('dashLeadsActivos').textContent = f.length
    document.getElementById('dashCierres').textContent = cierres
    document.getElementById('dashValorPipeline').textContent = window.fmt(totalVal)
    document.getElementById('dashCommTotal').textContent = window.fmt(totalComm)
    document.getElementById('dashCommM2M').textContent = window.fmt(totalM2M)
    document.getElementById('dashPeriodLabel').textContent = { semana: 'Esta Semana', mes: 'Este Mes', año: 'Este Año', todo: 'Todo' }[currentPeriod]

    // Calcular y mostrar rango de fechas
    const datesInPeriod = f.filter(l => l.travelDate).map(l => new Date(l.travelDate)).filter(d => !isNaN(d) && d.getFullYear() >= 2020)
    if (datesInPeriod.length > 0) {
        const minDate = new Date(Math.min(...datesInPeriod))
        const maxDate = new Date(Math.max(...datesInPeriod))
        const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
        const formatShort = d => `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`
        document.getElementById('dashDateRange').textContent = `📅 Viajes del ${formatShort(minDate)} al ${formatShort(maxDate)} (${f.length} leads)`
    } else {
        document.getElementById('dashDateRange').textContent = ''
    }

    // Por responsable (exclude cancelado from financials)
    const byResp = {}
    activeForFinancials.forEach(l => { const r = l.responsable || 'Sin asignar'; if (!byResp[r]) byResp[r] = { count: 0, val: 0, m2m: 0 }; byResp[r].count++; byResp[r].val += l.totalVenta || 0; byResp[r].m2m += l.commission70 || 0 })
    document.getElementById('dashByResponsable').innerHTML = Object.entries(byResp).sort((a, b) => b[1].m2m - a[1].m2m).map(([n, d]) => `<div class="dash-metric"><span class="dash-metric-label">${n} (${d.count})</span><span class="dash-metric-val">${window.fmt(d.val)} / ${window.fmt(d.m2m)}</span></div>`).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'

    // Por tipo (exclude cancelado from financials)
    const byTipo = {}
    activeForFinancials.forEach(l => { const t = TYPE_LABELS[l.type] || 'Otro'; if (!byTipo[t]) byTipo[t] = { count: 0, val: 0 }; byTipo[t].count++; byTipo[t].val += l.totalVenta || 0 })
    document.getElementById('dashByTipo').innerHTML = Object.entries(byTipo).sort((a, b) => b[1].val - a[1].val).map(([n, d]) => `<div class="dash-metric"><span class="dash-metric-label">${n} (${d.count})</span><span class="dash-metric-val">${window.fmt(d.val)}</span></div>`).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'

    // Por etapa
    const byEtapa = {}
    f.forEach(l => { const s = STAGES.find(s => s.id === l.stage)?.name || l.stage; if (!byEtapa[s]) byEtapa[s] = 0; byEtapa[s]++ })
    document.getElementById('dashByEtapa').innerHTML = Object.entries(byEtapa).sort((a, b) => b[1] - a[1]).slice(0, 6).map(([n, c]) => `<div class="dash-metric"><span class="dash-metric-label">${n}</span><span class="dash-metric-val">${c}</span></div>`).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'

    // Top M2M
    const topM2M = Object.values(clients).map(c => ({ name: c.titular, m2m: window.getClientM2MTotal(c) })).filter(c => c.m2m > 0).sort((a, b) => b.m2m - a.m2m).slice(0, 5)
    document.getElementById('dashTopM2M').innerHTML = topM2M.map(c => `<div class="dash-metric"><span class="dash-metric-label">${c.name}</span><span class="dash-metric-val" style="color:var(--green)">${window.fmt(c.m2m)}</span></div>`).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'

    // ========== COMISIONES POR AÑO (scope-aware) ==========
    const byYear = {}
    let validRecordsCount = 0
    let validVenta = 0
    let validComm = 0
    let validM2M = 0
    const yearCountLabel = currentDashScope === 'empresas' ? 'reservas' : currentDashScope === 'combinado' ? 'registros' : 'viajes'

    // Turismo data (turismo + combinado scopes) — exclude cancelado
    if (currentDashScope !== 'empresas') {
        [...leads, ...historico].filter(l => l.stage !== 'cancelado' && l.stage !== 'no_compro' && !l.wasCanceled).forEach(l => {
            if (!l.travelDate) return
            const date = new Date(l.travelDate)
            const year = date.getFullYear()
            if (isNaN(year) || year < 2020 || year > 2100) return
            if (!byYear[year]) byYear[year] = { count: 0, venta: 0, comm: 0, m2m: 0 }
            byYear[year].count++
            byYear[year].venta += l.totalVenta || 0
            byYear[year].comm += l.commission || 0
            byYear[year].m2m += l.commission70 || 0
            validRecordsCount++
            validVenta += l.totalVenta || 0
            validComm += l.commission || 0
            validM2M += l.commission70 || 0
        })
    }

    // Empresas data (empresas + combinado scopes)
    if (currentDashScope !== 'turismo') {
        companyBookings.forEach(b => {
            if (!b.checkIn) return
            const date = new Date(b.checkIn)
            const year = date.getFullYear()
            if (isNaN(year) || year < 2020 || year > 2100) return
            if (!byYear[year]) byYear[year] = { count: 0, venta: 0, comm: 0, m2m: 0 }
            byYear[year].count++
            byYear[year].venta += b.totalPurchase || 0
            byYear[year].comm += b.commissionAmount || 0
            byYear[year].m2m += b.m2mAmount || 0
            validRecordsCount++
            validVenta += b.totalPurchase || 0
            validComm += b.commissionAmount || 0
            validM2M += b.m2mAmount || 0
        })
    }

    // Ordenar años válidos
    const years = Object.keys(byYear).filter(y => !isNaN(y) && parseInt(y) >= 2020).sort()

    // Total histórico (solo registros válidos)
    const totalHistorico = {
        count: validRecordsCount,
        venta: validVenta,
        comm: validComm,
        m2m: validM2M
    }

    // Encontrar el máximo M2M para la barra de proporción
    const maxM2M = Math.max(...Object.values(byYear).map(y => y.m2m), 1)

    // Renderizar tarjetas por año
    let yearHTML = ''

    years.forEach((year, idx) => {
        const data = byYear[year]
        const prevYear = years[idx - 1]
        const prevData = prevYear ? byYear[prevYear] : null

        // Calcular crecimiento vs año anterior
        let growthBadge = ''
        if (prevData && prevData.m2m > 0) {
            const growth = ((data.m2m - prevData.m2m) / prevData.m2m * 100).toFixed(0)
            if (growth > 0) {
                growthBadge = `<span class="year-card-badge up">↑ ${growth}%</span>`
            } else if (growth < 0) {
                growthBadge = `<span class="year-card-badge down">↓ ${Math.abs(growth)}%</span>`
            } else {
                growthBadge = `<span class="year-card-badge neutral">= 0%</span>`
            }
        }

        // Color de la barra según el año
        const barColors = { 2024: '#6366f1', 2025: '#22c55e', 2026: '#f59e0b' }
        const barColor = barColors[year] || '#6b7280'
        const barWidth = (data.m2m / maxM2M * 100).toFixed(1)

        yearHTML += `
            <div class="year-card">
                <div class="year-card-header">
                    <span class="year-card-title">${year}</span>
                    ${growthBadge}
                </div>
                <div class="year-card-stats">
                    <div class="year-stat">
                        <div class="year-stat-val" style="color:var(--green)">${window.fmt(data.venta)}</div>
                        <div class="year-stat-label">Ventas</div>
                    </div>
                    <div class="year-stat">
                        <div class="year-stat-val" style="color:var(--green)">${window.fmt(data.m2m)}</div>
                        <div class="year-stat-label">M2M (70%)</div>
                    </div>
                </div>
                <div class="year-bar"><div class="year-bar-fill" style="width:${barWidth}%;background:${barColor}"></div></div>
                <div class="year-card-count">${data.count} ${yearCountLabel} • Comisión total: ${window.fmt(data.comm)}</div>
            </div>
        `
    })

    // Tarjeta de TOTAL HISTÓRICO
    yearHTML += `
        <div class="year-card total">
            <div class="year-card-header">
                <span class="year-card-title">📊 TOTAL</span>
                <span class="year-card-badge neutral">${currentDashScope === 'combinado' ? 'Turismo + Empresas' : currentDashScope === 'empresas' ? 'Empresas' : 'Histórico'}</span>
            </div>
            <div class="year-card-stats">
                <div class="year-stat">
                    <div class="year-stat-val" style="color:var(--purple-light)">${window.fmt(totalHistorico.venta)}</div>
                    <div class="year-stat-label">Ventas</div>
                </div>
                <div class="year-stat">
                    <div class="year-stat-val" style="color:var(--purple-light)">${window.fmt(totalHistorico.m2m)}</div>
                    <div class="year-stat-label">M2M (70%)</div>
                </div>
            </div>
            <div class="year-bar"><div class="year-bar-fill" style="width:100%;background:var(--purple)"></div></div>
            <div class="year-card-count">${totalHistorico.count} ${yearCountLabel} totales • Comisión: ${window.fmt(totalHistorico.comm)}</div>
        </div>
    `

    document.getElementById('dashYearComparison').innerHTML = yearHTML
    const yearTitleSuffix = currentDashScope === 'empresas' ? ' — Empresas' : currentDashScope === 'combinado' ? ' — Turismo + Empresas' : ''
    document.getElementById('dashYearTitle').textContent = '📈 Comisiones por Año' + yearTitleSuffix

    // ========== PRÓXIMOS CUMPLEAÑOS ==========
    const cumpleanos = []
    const hoy = new Date()
    hoy.setHours(0, 0, 0, 0)

    ;[...leads, ...historico].forEach(l => {
        const viajeros = l.grupoViajeros || []
        viajeros.forEach(v => {
            if (v.fechaNacimiento) {
                const birthDate = new Date(v.fechaNacimiento)
                // Próximo cumpleaños (este año o el siguiente)
                let nextBday = new Date(hoy.getFullYear(), birthDate.getMonth(), birthDate.getDate())
                if (nextBday < hoy) {
                    nextBday = new Date(hoy.getFullYear() + 1, birthDate.getMonth(), birthDate.getDate())
                }
                const diasPara = Math.ceil((nextBday - hoy) / (1000 * 60 * 60 * 24))
                const edad = nextBday.getFullYear() - birthDate.getFullYear()

                if (diasPara <= 60) { // Próximos 60 días
                    cumpleanos.push({
                        nombre: v.nombre,
                        edad,
                        diasPara,
                        fecha: nextBday,
                        leadId: l.id,
                        titular: l.titular || l.clientName
                    })
                }
            }
        })
    })

    cumpleanos.sort((a, b) => a.diasPara - b.diasPara)
    const top5Cumples = cumpleanos.slice(0, 5)

    document.getElementById('dashCumpleanos').innerHTML = top5Cumples.length ?
        top5Cumples.map(c => {
            const diasLabel = c.diasPara === 0 ? '🎉 ¡Hoy!' : c.diasPara === 1 ? 'Mañana' : `En ${c.diasPara} días`
            const diasColor = c.diasPara <= 1 ? 'var(--green)' : c.diasPara <= 7 ? 'var(--yellow)' : 'var(--text-2)'
            return `<div class="dash-metric" style="cursor:pointer;" onclick="openPanel('${c.leadId}')">
                <span class="dash-metric-label">🎂 ${c.nombre.split(' ')[0]} (${c.edad} años)</span>
                <span class="dash-metric-val" style="color:${diasColor};font-size:11px;">${diasLabel}</span>
            </div>`
        }).join('') :
        '<div class="dash-metric"><span class="dash-metric-label" style="color:var(--text-3)">Sin cumpleaños próximos</span></div>'

    // ========== PRÓXIMOS HITOS ==========
    const hitos = []
    const hitosConfig = settings.hitos || defaultSettings.hitos

    leads.forEach(l => {
        if (!l.travelDate) return
        if (l.stage === 'cancelado' || l.stage === 'no_compro') return
        const travelDate = new Date(l.travelDate)
        if (isNaN(travelDate)) return
        // Only show hitos for confirmed bookings (deposit paid, not past final payment deadline)
        const hasDeposit = (l.abonado || 0) > 0
        if (!hasDeposit) return

        const titular = l.titular || 'Cliente'
        // Usar nombre y apellido
        const nameParts = titular.split(' ')
        const displayName = nameParts.length > 1 ? `${nameParts[0]} ${nameParts[1]}` : nameParts[0]
        const tipo = l.type || ''
        const platform = (l.platform || '').toLowerCase()
        const dest = (l.destination || '').toLowerCase()
        const allText = tipo + ' ' + platform + ' ' + dest

        // Determinar operadores aplicables (additive — a lead can have multiple trip types)
        const operadoresAplicables = []
        const isCruise = tipo === 'crucero' || allText.includes('cruise') || allText.includes('crucero') || allText.includes('msc') || allText.includes('royal caribbean')
        const isDisney = tipo === 'disney' || allText.includes('disney')
        const isUniversal = tipo === 'universal' || allText.includes('universal')
        const isHotel = tipo === 'hotel' || (allText.includes('hotel') && !allText.includes('disney'))

        // Cruise (Disney Cruise gets disney_cruise + crucero; other cruises just crucero)
        if (isCruise && isDisney) {
            operadoresAplicables.push('disney_cruise', 'crucero')
        } else if (isCruise) {
            operadoresAplicables.push('crucero')
        }
        // Disney parks (only if NOT on a cruise — cruise clients don't need Lightning Lane etc.)
        if (isDisney && !isCruise) {
            operadoresAplicables.push('disney')
        }
        // Universal (additive — can combine with any other type)
        if (isUniversal) {
            operadoresAplicables.push('universal')
        }
        // Hotel (additive)
        if (isHotel) {
            operadoresAplicables.push('hotel')
        }
        if (operadoresAplicables.length === 0) {
            operadoresAplicables.push('otro')
        }

        // Hitos de operador desde configuración
        const hitosActivos = hitosConfig.filter(h => h.activo && operadoresAplicables.includes(h.operador))

        // Check if lead has Disney Dining Plan (for dining-specific hitos)
        const hasDiningPlan = l.parkEntries?.some(pe => pe.diningPlan && pe.diningPlan !== 'none' && pe.diningPlan !== '') ||
            (l.formData?.diningPlanType && l.formData.diningPlanType !== 'none') ||
            l.hasDiningPlan

        hitosActivos.forEach(hito => {
            // Skip Disney parks dining hitos if lead doesn't have a Dining Plan
            const isDiningHito = hito.operador === 'disney' && hito.nombre?.toLowerCase().includes('dining')
            if (isDiningHito && !hasDiningPlan) return

            const hitoDate = new Date(travelDate)
            hitoDate.setDate(hitoDate.getDate() - hito.dias)
            const diasHito = Math.ceil((hitoDate - hoy) / (1000 * 60 * 60 * 24))
            if (diasHito >= -7 && diasHito <= 90) {
                const mainOp = operadoresAplicables[0] || 'otro'
                hitos.push({ icon: hito.icon, label: `${hito.nombre.split(' ')[0]} ${displayName}`, dias: diasHito, leadId: l.id, tipo: mainOp, hitoNombre: hito.nombre, titular: displayName })
            }
        })

        // Viaje próximo (always included regardless of operator type)
        const diasViaje = Math.ceil((travelDate - hoy) / (1000 * 60 * 60 * 24))
        if (diasViaje >= -1 && diasViaje <= 7) {
            const mainOp = operadoresAplicables[0] || 'otro'
            const travelIcon = isCruise ? '🚢' : mainOp === 'universal' ? '🎢' : mainOp === 'hotel' ? '🏨' : '✈️'
            hitos.push({ icon: travelIcon, label: `Viaje ${displayName}`, dias: diasViaje, leadId: l.id, tipo: mainOp, hitoNombre: 'Viaje', titular: displayName })
        }

        // Pagos (siempre incluidos)
        if (l.fechaAbono && (l.abonado || 0) < (l.abono || 0)) {
            const diasAbono = Math.ceil((new Date(l.fechaAbono) - hoy) / (1000 * 60 * 60 * 24))
            if (diasAbono >= -7 && diasAbono <= 90) {
                const mainOp = operadoresAplicables[0] || 'otro'
                hitos.push({ icon: '💰', label: `Abono ${displayName}`, dias: diasAbono, leadId: l.id, tipo: 'pago', hitoNombre: 'Abono', titular: displayName })
            }
        }

        if (l.fechaPagoFinal && (l.abonado || 0) < (l.totalVenta || 0)) {
            const diasPago = Math.ceil((new Date(l.fechaPagoFinal) - hoy) / (1000 * 60 * 60 * 24))
            if (diasPago >= -7 && diasPago <= 90) {
                hitos.push({ icon: '💰', label: `Pago Final ${displayName}`, dias: diasPago, leadId: l.id, tipo: 'pago', hitoNombre: 'Pago Final', titular: displayName })
            }
        }
    })

    hitos.sort((a, b) => a.dias - b.dias)
    window._allHitos = hitos
    // Dashboard preview: closest 5 within -3..14 days
    const previewHitos = hitos.filter(h => h.dias >= -3 && h.dias <= 14).slice(0, 5)

    const hitosMapFn = h => {
        const diasLabel = h.dias < 0 ? `¡${Math.abs(h.dias)}d atrás!` : h.dias === 0 ? '¡Hoy!' : h.dias === 1 ? 'Mañana' : `En ${h.dias} días`
        const diasColor = h.dias < 0 ? 'var(--red)' : h.dias <= 1 ? 'var(--green)' : h.dias <= 3 ? 'var(--yellow)' : 'var(--text-2)'
        return `<div class="dash-metric" style="cursor:pointer;" onclick="openPanel('${h.leadId}')">
            <span class="dash-metric-label">${h.icon} ${h.label}</span>
            <span class="dash-metric-val" style="color:${diasColor};font-size:11px;">${diasLabel}</span>
        </div>`
    }

    let hitosHTML = previewHitos.length ? previewHitos.map(hitosMapFn).join('') : '<div class="dash-metric"><span class="dash-metric-label" style="color:var(--text-3)">Sin hitos próximos</span></div>'
    if (hitos.length > 5) {
        hitosHTML += `<div style="text-align:center;margin-top:8px;">
            <button onclick="openHitosModal()" style="background:none;border:none;color:var(--blue);cursor:pointer;font-size:12px;text-decoration:underline;">
                Ver todos (${hitos.length})
            </button>
        </div>`
    }
    document.getElementById('dashHitos').innerHTML = hitosHTML

    // ========== EMPRESAS DASHBOARD ==========
    const empBookingsFiltered = (() => {
        let eb = [...companyBookings]
        if (currentPeriod === 'semana') eb = eb.filter(b => b.checkIn && new Date(b.checkIn) >= new Date(now - 7*24*60*60*1000) && new Date(b.checkIn) <= new Date(now.getTime() + 7*24*60*60*1000))
        else if (currentPeriod === 'mes') eb = eb.filter(b => b.checkIn && new Date(b.checkIn).getMonth() === now.getMonth() && new Date(b.checkIn).getFullYear() === now.getFullYear())
        else if (currentPeriod === 'año') eb = eb.filter(b => b.checkIn && new Date(b.checkIn).getFullYear() === now.getFullYear())
        return eb
    })()

    const empTotalPurchase = empBookingsFiltered.reduce((s, b) => s + (b.totalPurchase || 0), 0)
    const empTotalComm = empBookingsFiltered.reduce((s, b) => s + (b.commissionAmount || 0), 0)
    const empTotalM2M = empBookingsFiltered.reduce((s, b) => s + (b.m2mAmount || 0), 0)
    const empPagado = empBookingsFiltered.filter(b => b.stage === 'pagado').length

    // Update top stats based on scope
    if (currentDashScope === 'empresas') {
        document.getElementById('dashTotalClientes').textContent = companies.filter(c => c.active !== false).length
        document.getElementById('dashLblClientes').textContent = 'Empresas'
        document.getElementById('dashLeadsActivos').textContent = empBookingsFiltered.length
        document.getElementById('dashLblLeads').textContent = 'Reservas'
        document.getElementById('dashCierres').textContent = empPagado
        document.getElementById('dashLblCierres').textContent = 'Pagados'
        document.getElementById('dashValorPipeline').textContent = window.fmtUSD(empTotalPurchase)
        document.getElementById('dashCommTotal').textContent = window.fmtUSD(empTotalComm)
        document.getElementById('dashCommM2M').textContent = window.fmtUSD(empTotalM2M)
        document.getElementById('dashDateRange').textContent = ''
    } else if (currentDashScope === 'combinado') {
        const combClientes = uniqueClients + companies.filter(c => c.active !== false).length
        const combLeads = f.length + empBookingsFiltered.length
        const combVal = totalVal + empTotalPurchase
        const combComm = totalComm + empTotalComm
        const combM2M = totalM2M + empTotalM2M
        document.getElementById('dashTotalClientes').textContent = combClientes
        document.getElementById('dashLblClientes').textContent = 'Clientes + Empresas'
        document.getElementById('dashLeadsActivos').textContent = combLeads
        document.getElementById('dashLblLeads').textContent = 'Leads + Reservas'
        document.getElementById('dashCierres').textContent = cierres + empPagado
        document.getElementById('dashLblCierres').textContent = 'Cierres + Pagados'
        document.getElementById('dashValorPipeline').textContent = window.fmt(combVal)
        document.getElementById('dashCommTotal').textContent = window.fmt(combComm)
        document.getElementById('dashCommM2M').textContent = window.fmt(combM2M)
    } else {
        // turismo (default) — restore labels
        document.getElementById('dashLblClientes').textContent = 'Total Clientes'
        document.getElementById('dashLblLeads').textContent = 'Leads Activos'
        document.getElementById('dashLblCierres').textContent = 'Cierres'
    }

    // Empresas cards
    if (currentDashScope === 'empresas' || currentDashScope === 'combinado') {
        // By Company
        const byComp = {}
        empBookingsFiltered.forEach(b => {
            const name = companies.find(c => c.id === b.companyId)?.name || 'Sin empresa'
            if (!byComp[name]) byComp[name] = { count: 0, purchase: 0, m2m: 0 }
            byComp[name].count++
            byComp[name].purchase += b.totalPurchase || 0
            byComp[name].m2m += b.m2mAmount || 0
        })
        const byCompEl = document.getElementById('dashEmpByCompany')
        if (byCompEl) byCompEl.innerHTML = Object.entries(byComp).sort((a, b) => b[1].m2m - a[1].m2m).map(([n, d]) =>
            `<div class="dash-metric"><span class="dash-metric-label">${n} (${d.count})</span><span class="dash-metric-val">${window.fmtUSD(d.m2m)}</span></div>`
        ).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'

        // By Stage
        const byStg = {}
        empBookingsFiltered.forEach(b => {
            const name = EMPRESAS_STAGES.find(s => s.id === b.stage)?.name || b.stage
            if (!byStg[name]) byStg[name] = 0
            byStg[name]++
        })
        const byStgEl = document.getElementById('dashEmpByStage')
        if (byStgEl) byStgEl.innerHTML = Object.entries(byStg).sort((a, b) => b[1] - a[1]).map(([n, c]) =>
            `<div class="dash-metric"><span class="dash-metric-label">${n}</span><span class="dash-metric-val">${c}</span></div>`
        ).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'

        // Monthly breakdown
        const byMonth = {}
        empBookingsFiltered.forEach(b => {
            if (!b.checkIn) return
            const d = new Date(b.checkIn)
            const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
            if (!byMonth[key]) byMonth[key] = { count: 0, purchase: 0, m2m: 0 }
            byMonth[key].count++
            byMonth[key].purchase += b.totalPurchase || 0
            byMonth[key].m2m += b.m2mAmount || 0
        })
        const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
        const monthEl = document.getElementById('dashEmpMonthly')
        if (monthEl) monthEl.innerHTML = Object.entries(byMonth).sort((a, b) => b[0].localeCompare(a[0])).slice(0, 6).map(([k, d]) => {
            const [y, m] = k.split('-')
            return `<div class="dash-metric"><span class="dash-metric-label">${months[parseInt(m) - 1]} ${y} (${d.count})</span><span class="dash-metric-val">${window.fmtUSD(d.m2m)}</span></div>`
        }).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'

        // Top Travelers
        const byTraveler = {}
        empBookingsFiltered.forEach(b => {
            const name = b.travelerName || 'Sin nombre'
            if (!byTraveler[name]) byTraveler[name] = { count: 0, purchase: 0 }
            byTraveler[name].count++
            byTraveler[name].purchase += b.totalPurchase || 0
        })
        const travEl = document.getElementById('dashEmpTopTravelers')
        if (travEl) travEl.innerHTML = Object.entries(byTraveler).sort((a, b) => b[1].purchase - a[1].purchase).slice(0, 5).map(([n, d]) =>
            `<div class="dash-metric"><span class="dash-metric-label">${n} (${d.count})</span><span class="dash-metric-val">${window.fmtUSD(d.purchase)}</span></div>`
        ).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'
    }

    // Combinado summary cards
    if (currentDashScope === 'combinado') {
        const combTurEl = document.getElementById('dashCombTurismo')
        if (combTurEl) combTurEl.innerHTML = `
            <div class="dash-metric"><span class="dash-metric-label">Leads</span><span class="dash-metric-val">${f.length}</span></div>
            <div class="dash-metric"><span class="dash-metric-label">Ventas</span><span class="dash-metric-val" style="color:var(--green)">${window.fmt(totalVal)}</span></div>
            <div class="dash-metric"><span class="dash-metric-label">Comisión</span><span class="dash-metric-val" style="color:var(--yellow)">${window.fmt(totalComm)}</span></div>
            <div class="dash-metric"><span class="dash-metric-label">M2M (70%)</span><span class="dash-metric-val" style="color:var(--green)">${window.fmt(totalM2M)}</span></div>`
        const combEmpEl = document.getElementById('dashCombEmpresas')
        if (combEmpEl) combEmpEl.innerHTML = `
            <div class="dash-metric"><span class="dash-metric-label">Reservas</span><span class="dash-metric-val">${empBookingsFiltered.length}</span></div>
            <div class="dash-metric"><span class="dash-metric-label">Compras</span><span class="dash-metric-val" style="color:var(--blue)">${window.fmtUSD(empTotalPurchase)}</span></div>
            <div class="dash-metric"><span class="dash-metric-label">Comisión</span><span class="dash-metric-val" style="color:var(--yellow)">${window.fmtUSD(empTotalComm)}</span></div>
            <div class="dash-metric"><span class="dash-metric-label">M2M (70%)</span><span class="dash-metric-val" style="color:var(--green)">${window.fmtUSD(empTotalM2M)}</span></div>`
    }

}

function setPeriod(p) {
    const { } = store || {}
    store.currentPeriod = p
    document.querySelectorAll(`.period-tab[onclick^="setPeriod"]`).forEach(t => t.classList.remove('active'))
    document.querySelector(`.period-tab[onclick="setPeriod('${p}')"]`)?.classList.add('active')
    window.renderDashboard()
}

// ========== FORM ANALYTICS ==========


function getFormPhaseForStep(stepId) {
    for (const phase of FORM_STEP_PHASES) {
        if (phase.steps.includes(stepId)) return phase
    }
    return FORM_STEP_PHASES[3] // Default to "Detalles"
}

function getFormPhaseIndex(stepId) {
    const idx = FORM_STEP_PHASES.findIndex(p => p.steps.includes(stepId))
    return idx >= 0 ? idx : 3
}

async function refreshFormSubmissions() {
    const [subData, sessData] = await Promise.all([
        window.supabaseDB.fetchAllFormSubmissions(),
        window.supabaseDB.fetchAllFormSessions(),
    ])
    const state = store || {}
    if (subData) { state.allFormSubmissions = subData; state.formSubsLoaded = true; state._kpiFormsLoaded = true }
    if (sessData) { state.allFormSessions = sessData; state.formSessionsLoaded = true }
    renderFormularios()
}

function filterFormSubmissions() {
    const { allFormSubmissions, formPeriod, formStatusFilter } = store || {}
    let f = allFormSubmissions
    const now = new Date()
    if (formPeriod === 'semana') { const wa = new Date(now - 7*864e5); f = f.filter(s => new Date(s.created_at) >= wa) }
    else if (formPeriod === 'mes') { f = f.filter(s => { const d = new Date(s.created_at); return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear() }) }
    else if (formPeriod === 'año') { f = f.filter(s => new Date(s.created_at).getFullYear() === now.getFullYear()) }
    if (formStatusFilter !== 'todos') f = f.filter(s => s.status === formStatusFilter)
    return f
}

function renderFormularios() {
    const { formSubsLoaded } = store || {}
    if (!formSubsLoaded) { refreshFormSubmissions(); return }
    const filtered = filterFormSubmissions()
    renderFormStats(filtered)
    renderFormTripTypeChart(filtered)
    renderFormSourceChart(filtered)
    renderFormDestinationChart(filtered)
    renderFormConversionFunnel()
    renderFormStepFunnel()
    renderFormDropoffHotspots()
    renderFormTimePerPhase()
    renderFormDemandCalendar(filtered)
    renderFormTable(filtered)
    window.updateFormBadge()
}

function renderFormStats(filtered) {
    const { allFormSubmissions, allFormSessions, formSessionsLoaded } = store || {}
    const now = new Date(), wa = new Date(now - 7*864e5), all = allFormSubmissions
    document.getElementById('formTotalSubs').textContent = all.length
    document.getElementById('formThisWeek').textContent = all.filter(s => new Date(s.created_at) >= wa).length
    document.getElementById('formThisMonth').textContent = all.filter(s => { const d = new Date(s.created_at); return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear() }).length
    const withTime = all.filter(s => s.data?.started_at)
    if (withTime.length > 0) {
        const avgSec = Math.round(withTime.reduce((sum, s) => sum + (new Date(s.created_at) - new Date(s.data.started_at)) / 1000, 0) / withTime.length)
        const m = Math.floor(avgSec / 60), s = avgSec % 60
        document.getElementById('formAvgTime').textContent = m >= 60 ? `${Math.floor(m/60)}h ${m%60}m` : `${m}m ${s}s`
    } else { document.getElementById('formAvgTime').textContent = '—' }
    const converted = all.filter(s => s.status === 'converted').length
    document.getElementById('formConvRate').textContent = (all.length > 0 ? Math.round(converted / all.length * 100) : 0) + '%'
    document.getElementById('formNewCount').textContent = all.filter(s => s.status === 'new').length

    // Session-based stats (abandon rate + active now)
    if (formSessionsLoaded && allFormSessions.length > 0) {
        const thirtyMinAgo = new Date(Date.now() - 30 * 60 * 1000)
        const abandoned = allFormSessions.filter(s => !s.completed && new Date(s.last_activity) < thirtyMinAgo).length
        const totalSessions = allFormSessions.length
        document.getElementById('formAbandonRate').textContent = (totalSessions > 0 ? Math.round(abandoned / totalSessions * 100) : 0) + '%'
        const fiveMinAgo = new Date(Date.now() - 5 * 60 * 1000)
        const activeCount = allFormSessions.filter(s => !s.completed && new Date(s.last_activity) >= fiveMinAgo).length
        document.getElementById('formActiveNow').innerHTML = (activeCount > 0 ? '<span class="form-active-dot"></span>' : '') + activeCount
    } else {
        document.getElementById('formAbandonRate').textContent = '—'
        document.getElementById('formActiveNow').textContent = '0'
    }
}

function renderFormTripTypeChart(filtered) {
    const { formPeriod } = store || {}
    const byType = {}
    filtered.forEach(s => {
        const tipos = s.data?.tiposViaje || s.data?._tripBranches || []
        if (!tipos.length) { byType['Otro'] = (byType['Otro'] || 0) + 1 }
        else tipos.forEach(t => { const lb = FORM_TRIP_LABELS[t] || t; byType[lb] = (byType[lb] || 0) + 1 })
    })
    const total = filtered.length || 1
    const sorted = Object.entries(byType).sort((a, b) => b[1] - a[1])
    const colors = ['var(--purple)', 'var(--cyan)', 'var(--green)', 'var(--yellow)', 'var(--red)', 'var(--blue)']
    document.getElementById('formByTripType').innerHTML = sorted.map(([name, count], i) => {
        const pct = Math.round(count / total * 100)
        return `<div style="margin-bottom:10px;"><div style="display:flex;justify-content:space-between;margin-bottom:4px;"><span style="font-size:13px;color:var(--text-2);">${name}</span><span style="font-size:13px;font-weight:600;">${count} (${pct}%)</span></div><div class="year-bar"><div class="year-bar-fill" style="width:${pct}%;background:${colors[i%colors.length]}"></div></div></div>`
    }).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'
    document.getElementById('formChartPeriodLabel').textContent = { semana: 'Esta Semana', mes: 'Este Mes', año: 'Este Año', todo: 'Todo' }[formPeriod]
}

function renderFormSourceChart(filtered) {
    const bySource = {}
    filtered.forEach(s => {
        const fuentes = s.data?.fuente || []
        if (!fuentes.length) { bySource['Desconocido'] = (bySource['Desconocido'] || 0) + 1 }
        else if (Array.isArray(fuentes)) fuentes.forEach(f => { bySource[f] = (bySource[f] || 0) + 1 })
        else { bySource[fuentes] = (bySource[fuentes] || 0) + 1 }
    })
    const total = filtered.length || 1
    const sorted = Object.entries(bySource).sort((a, b) => b[1] - a[1])
    const colors = ['var(--green)', 'var(--blue)', 'var(--purple)', 'var(--yellow)', 'var(--cyan)', 'var(--red)']
    document.getElementById('formBySource').innerHTML = sorted.map(([name, count], i) => {
        const pct = Math.round(count / total * 100)
        return `<div style="margin-bottom:10px;"><div style="display:flex;justify-content:space-between;margin-bottom:4px;"><span style="font-size:13px;color:var(--text-2);">${name}</span><span style="font-size:13px;font-weight:600;">${count} (${pct}%)</span></div><div class="year-bar"><div class="year-bar-fill" style="width:${pct}%;background:${colors[i%colors.length]}"></div></div></div>`
    }).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'
}

function renderFormDestinationChart(filtered) {
    const byDest = {}
    filtered.forEach(s => {
        const d = s.data || {}
        if (d.disneyDestino) { const lb = FORM_DEST_MAP[d.disneyDestino] || d.disneyDestino; byDest[lb] = (byDest[lb] || 0) + 1 }
        if (d.universalDestino) { const lb = FORM_DEST_MAP[d.universalDestino] || d.universalDestino; byDest[lb] = (byDest[lb] || 0) + 1 }
        ;(d.destinosCrucero || []).forEach(c => { byDest[c] = (byDest[c] || 0) + 1 })
        if (d.destinoHotel) { byDest[d.destinoHotel] = (byDest[d.destinoHotel] || 0) + 1 }
        if (d.eventoTipo) { byDest['Evento: ' + d.eventoTipo] = (byDest['Evento: ' + d.eventoTipo] || 0) + 1 }
    })
    const sorted = Object.entries(byDest).sort((a, b) => b[1] - a[1]).slice(0, 8)
    const max = sorted[0]?.[1] || 1
    document.getElementById('formByDestination').innerHTML = sorted.map(([name, count]) =>
        `<div class="dash-metric"><span class="dash-metric-label">${name}</span><span class="dash-metric-val">${count}</span></div>`
    ).join('') || '<div class="dash-metric"><span class="dash-metric-label">Sin datos</span></div>'
}

function renderFormConversionFunnel() {
    const { allFormSubmissions } = store || {}
    const all = allFormSubmissions, total = all.length
    const contacted = all.filter(s => ['contacted', 'converted'].includes(s.status)).length
    const withLead = all.filter(s => s.lead_id).length
    const converted = all.filter(s => s.status === 'converted').length
    const steps = [
        { label: 'Solicitudes', count: total, color: 'var(--cyan)' },
        { label: 'Contactados', count: contacted, color: 'var(--yellow)' },
        { label: 'Lead Creado', count: withLead, color: 'var(--blue)' },
        { label: 'Convertido', count: converted, color: 'var(--green)' },
    ]
    const maxC = total || 1
    document.getElementById('formConversionFunnel').innerHTML = steps.map(s => {
        const pct = Math.round(s.count / maxC * 100)
        return `<div class="form-funnel-step"><span class="form-funnel-label">${s.label}</span><div class="form-funnel-bar"><div class="form-funnel-fill" style="width:${Math.max(pct, 2)}%;background:${s.color};">${pct}%</div></div><span class="form-funnel-count">${s.count}</span></div>`
    }).join('')
}

function renderFormStepFunnel() {
    const { allFormSessions, formSessionsLoaded } = store || {}
    const el = document.getElementById('formStepFunnel')
    if (!el) return
    if (!formSessionsLoaded || allFormSessions.length === 0) {
        el.innerHTML = '<div style="color:var(--text-3);padding:20px;">Sin datos de sesiones</div>'
        return
    }
    const sessions = allFormSessions, total = sessions.length
    const colors = ['var(--cyan)', 'var(--blue)', 'var(--purple)', '#a855f7', 'var(--yellow)', '#f59e0b', 'var(--green)', '#22c55e']
    const phaseCounts = FORM_STEP_PHASES.map((phase, i) => {
        const count = sessions.filter(s => {
            const visited = s.steps_visited || []
            return visited.some(stepId => getFormPhaseIndex(stepId) >= i)
        }).length
        return { ...phase, count }
    })
    el.innerHTML = phaseCounts.map((p, i) => {
        const pct = Math.round(p.count / total * 100)
        return `<div class="form-step-funnel-bar">
            <span class="form-step-funnel-phase">${p.label}</span>
            <div class="form-step-funnel-fill-wrap"><div class="form-step-funnel-fill" style="width:${Math.max(pct, 2)}%;background:${colors[i]}"><span class="form-step-funnel-pct">${pct}%</span></div></div>
            <span class="form-step-funnel-count">${p.count}</span>
        </div>`
    }).join('')
}

function renderFormDropoffHotspots() {
    const { allFormSessions, formSessionsLoaded } = store || {}
    const el = document.getElementById('formDropoffHotspots')
    if (!el) return
    if (!formSessionsLoaded) { el.innerHTML = '<div style="color:var(--text-3);padding:20px;">Cargando...</div>'; return }
    const thirtyMinAgo = new Date(Date.now() - 30 * 60 * 1000)
    const abandoned = allFormSessions.filter(s => !s.completed && new Date(s.last_activity) < thirtyMinAgo)
    if (abandoned.length === 0) { el.innerHTML = '<div style="color:var(--text-3);padding:20px;">Sin abandonos registrados</div>'; return }
    const byPhase = {}
    abandoned.forEach(s => {
        const phase = getFormPhaseForStep(s.last_step)
        const key = phase ? phase.label : (s.last_step || 'Desconocido')
        byPhase[key] = (byPhase[key] || 0) + 1
    })
    const sorted = Object.entries(byPhase).sort((a, b) => b[1] - a[1]).slice(0, 8)
    const maxCount = sorted[0]?.[1] || 1
    el.innerHTML = sorted.map(([phase, count]) => {
        const pct = Math.round(count / maxCount * 100)
        return `<div class="form-dropoff-row">
            <span class="form-dropoff-step" title="${phase}">${phase}</span>
            <div class="form-dropoff-bar"><div class="form-dropoff-fill" style="width:${pct}%;background:var(--red);opacity:${(0.4 + (count / maxCount) * 0.6).toFixed(2)}"></div></div>
            <span class="form-dropoff-count">${count}</span>
        </div>`
    }).join('')
}

function renderFormTimePerPhase() {
    const { allFormSessions, formSessionsLoaded } = store || {}
    const el = document.getElementById('formTimePerPhase')
    if (!el) return
    if (!formSessionsLoaded) { el.innerHTML = '<div style="color:var(--text-3);padding:20px;">Cargando...</div>'; return }
    const completed = allFormSessions.filter(s => s.completed && s.step_timestamps && Object.keys(s.step_timestamps).length > 1)
    if (completed.length === 0) { el.innerHTML = '<div style="color:var(--text-3);padding:20px;">Sin datos suficientes</div>'; return }
    const phaseTimeSums = {}, phaseTimeCounts = {}
    completed.forEach(s => {
        const ts = s.step_timestamps
        const sortedSteps = Object.entries(ts).sort((a, b) => new Date(a[1]) - new Date(b[1]))
        for (let i = 0; i < sortedSteps.length - 1; i++) {
            const [stepId, enterTime] = sortedSteps[i]
            const [, nextTime] = sortedSteps[i + 1]
            const phase = getFormPhaseForStep(stepId)
            if (!phase) continue
            const durationSec = (new Date(nextTime) - new Date(enterTime)) / 1000
            if (durationSec > 300 || durationSec < 0) continue
            phaseTimeSums[phase.label] = (phaseTimeSums[phase.label] || 0) + durationSec
            phaseTimeCounts[phase.label] = (phaseTimeCounts[phase.label] || 0) + 1
        }
    })
    const phaseAvgs = Object.entries(phaseTimeSums).map(([label, sum]) => ({
        label, avgSec: Math.round(sum / (phaseTimeCounts[label] || 1)),
    })).sort((a, b) => b.avgSec - a.avgSec)
    if (phaseAvgs.length === 0) { el.innerHTML = '<div style="color:var(--text-3);padding:20px;">Sin datos suficientes</div>'; return }
    const maxSec = phaseAvgs[0]?.avgSec || 1
    el.innerHTML = phaseAvgs.map(p => {
        const pct = Math.round(p.avgSec / maxSec * 100)
        const label = p.avgSec >= 60 ? `${Math.floor(p.avgSec / 60)}m ${p.avgSec % 60}s` : `${p.avgSec}s`
        return `<div class="form-time-row">
            <span class="form-time-phase">${p.label}</span>
            <div class="form-time-bar-wrap"><div class="form-time-bar-fill" style="width:${pct}%;background:var(--cyan);"></div></div>
            <span class="form-time-val">${label}</span>
        </div>`
    }).join('')
}

function renderFormDemandCalendar(filtered) {
    const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
    const byMonth = {}
    filtered.forEach(s => {
        const d = s.data || {}
        let dates = []
        if (d.fechaLlegada) dates.push(d.fechaLlegada)
        if (d.mesAproximado) {
            const yr = d.anioAproximado || new Date().getFullYear()
            const meses = Array.isArray(d.mesAproximado) ? d.mesAproximado : [d.mesAproximado]
            meses.forEach(mes => {
                const mi = MESES.findIndex(m => (mes || '').toLowerCase().startsWith(m.toLowerCase()))
                if (mi >= 0) dates.push(`${yr}-${String(mi + 1).padStart(2, '0')}-15`)
            })
        }
        dates.forEach(ds => {
            const dt = new Date(ds)
            if (!isNaN(dt) && dt.getFullYear() >= 2024) {
                const key = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`
                byMonth[key] = (byMonth[key] || 0) + 1
            }
        })
    })
    const now = new Date(), calMonths = []
    for (let i = 0; i < 12; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() + i, 1)
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
        calMonths.push({ key, label: MESES[d.getMonth()], year: d.getFullYear(), count: byMonth[key] || 0 })
    }
    const maxC = Math.max(...calMonths.map(m => m.count), 1)
    document.getElementById('formDemandCalendar').innerHTML = calMonths.map(m => {
        const intensity = Math.min(4, Math.ceil(m.count / maxC * 4))
        const pct = Math.round(m.count / maxC * 100)
        return `<div class="form-demand-month heat-${intensity}"><div class="form-demand-month-label">${m.label}${m.year !== now.getFullYear() ? ' ' + m.year : ''}</div><div class="form-demand-month-count" style="color:${intensity >= 2 ? 'var(--cyan)' : 'var(--text-2)'};">${m.count}</div><div class="form-demand-month-bar"><div class="form-demand-month-fill" style="width:${pct}%;background:var(--cyan)"></div></div></div>`
    }).join('')
}

function renderFormTable(filtered) {
    const { formSortField, formSortDir, formSelectedIds } = store || {}
    const sorted = [...filtered].sort((a, b) => {
        let va, vb
        if (formSortField === 'created_at') { va = a.created_at; vb = b.created_at }
        else if (formSortField === 'contact_name') { va = (a.contact_name || '').toLowerCase(); vb = (b.contact_name || '').toLowerCase() }
        else if (formSortField === 'trip_type') { va = (a.data?.tiposViaje || []).join(','); vb = (b.data?.tiposViaje || []).join(',') }
        else if (formSortField === 'status') { va = a.status; vb = b.status }
        else { va = a[formSortField]; vb = b[formSortField] }
        const cmp = va < vb ? -1 : va > vb ? 1 : 0
        return formSortDir === 'asc' ? cmp : -cmp
    })
    const fmtDt = (d) => { if (!d) return '—'; const dt = new Date(d); const ms = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic']; return `${dt.getDate()} ${ms[dt.getMonth()]} ${dt.getFullYear()}, ${String(dt.getHours()).padStart(2,'0')}:${String(dt.getMinutes()).padStart(2,'0')}` }
    document.getElementById('formTableBody').innerHTML = sorted.map(s => {
        const tipos = (s.data?.tiposViaje || s.data?._tripBranches || []).map(t => FORM_TRIP_LABELS[t] || t)
        const tripTags = tipos.map(t => `<span class="form-trip-tag">${t}</span>`).join('') || '<span style="color:var(--text-3);">—</span>'
        const travelInfo = getFormTravelSummary(s.data)
        const checked = formSelectedIds.has(s.id) ? 'checked' : ''
        const ph = (s.contact_phone || '').replace(/[^0-9]/g, '')
        return `<tr onclick="toggleFormDetail('${s.id}')" style="cursor:pointer;">
            <td onclick="event.stopPropagation()"><input type="checkbox" ${checked} onchange="formToggleRow('${s.id}', this.checked)"></td>
            <td style="white-space:nowrap;font-size:11px;">${fmtDt(s.created_at)}</td>
            <td style="font-weight:500;">${window.escHtml(s.contact_name || '—')}</td>
            <td><a href="https://wa.me/${ph}" target="_blank" onclick="event.stopPropagation();" style="color:var(--green);text-decoration:none;">${s.contact_phone || '—'}</a></td>
            <td style="font-size:11px;">${window.escHtml(s.contact_email || '—')}</td>
            <td><div class="form-trip-tags">${tripTags}</div></td>
            <td style="font-size:11px;max-width:140px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" title="${window.escHtml(travelInfo)}">${window.escHtml(travelInfo)}</td>
            <td onclick="event.stopPropagation()"><select class="form-status-select" onchange="changeFormStatus('${s.id}', this.value)"><option value="new" ${s.status==='new'?'selected':''}>Nuevo</option><option value="contacted" ${s.status==='contacted'?'selected':''}>Contactado</option><option value="converted" ${s.status==='converted'?'selected':''}>Convertido</option><option value="archived" ${s.status==='archived'?'selected':''}>Archivado</option></select></td>
            <td onclick="event.stopPropagation()" style="position:relative;"><button class="form-row-menu-btn" onclick="toggleFormRowMenu(event,'${s.id}',${!!s.lead_id})">⋮</button></td>
        </tr>
        <tr class="form-detail-row" id="formDetail_${s.id}"><td colspan="9" class="form-detail-cell">${buildFormDetailHTML(s)}</td></tr>`
    }).join('') || '<tr><td colspan="9" style="text-align:center;padding:40px;color:var(--text-3);">No hay solicitudes</td></tr>'
    const count = formSelectedIds.size
    const bulkBtn = document.getElementById('formBulkActions')
    if (bulkBtn) { bulkBtn.style.display = count > 0 ? '' : 'none'; bulkBtn.textContent = `Acciones (${count})` }
}

function getFormTravelSummary(data) {
    if (!data) return '—'
    const parts = []
    if (data.disneyDestino) parts.push(FORM_DEST_MAP[data.disneyDestino] || data.disneyDestino)
    if (data.universalDestino) parts.push(FORM_DEST_MAP[data.universalDestino] || data.universalDestino)
    if (data.destinosCrucero?.length) parts.push('Crucero: ' + data.destinosCrucero.join(', '))
    if (data.destinoHotel) parts.push(data.destinoHotel)
    if (data.eventoTipo) parts.push('Evento: ' + data.eventoTipo)
    return parts.join(' + ') || '—'
}

function buildFormDetailHTML(sub) {
    const d = sub.data || {}
    const row = (label, val) => val && val !== '' && val !== '0' ? `<div style="margin-bottom:6px;"><div class="form-detail-label">${label}</div><div class="form-detail-value">${window.escHtml(String(val))}</div></div>` : ''
    let html = '<div class="form-detail-grid">'
    html += row('Nombre', d.nombre)
    html += row('Teléfono', sub.contact_phone)
    html += row('Email', d.email)
    html += row('Tipos de Viaje', (d.tiposViaje || []).map(t => FORM_TRIP_LABELS[t] || t).join(', '))
    html += row('Adultos', d.adultos)
    html += row('Menores', d.menores > 0 ? `${d.menores} (edades: ${(d.edadesMenores || []).join(', ')})` : '')
    const fechaStr = d.fechaLlegada && d.fechaRegreso ? `${d.fechaLlegada} → ${d.fechaRegreso}` : (d.mesAproximado ? `${Array.isArray(d.mesAproximado) ? d.mesAproximado.join(', ') : d.mesAproximado} ${d.anioAproximado || ''}` : (d.temporadaFlexible ? `${Array.isArray(d.temporadaFlexible) ? d.temporadaFlexible.join(', ') : d.temporadaFlexible}${d.anioAproximado ? ' ' + d.anioAproximado : ''}` : ''))
    html += row('Fechas', fechaStr)
    html += row('Marca Parques', d.parquesMarca)
    html += row('Disney Destino', d.disneyDestino ? (FORM_DEST_MAP[d.disneyDestino] || d.disneyDestino) : '')
    html += row('Universal Destino', d.universalDestino ? (FORM_DEST_MAP[d.universalDestino] || d.universalDestino) : '')
    html += row('Días Disney', d.diasDisney > 0 ? d.diasDisney : '')
    html += row('Días Universal', d.diasUniversal > 0 ? d.diasUniversal : '')
    html += row('Primera vez Disney', d.primeraVezDisney != null ? (d.primeraVezDisney ? 'Sí' : 'No') : '')
    html += row('Primera vez Universal', d.primeraVezUniversal != null ? (d.primeraVezUniversal ? 'Sí' : 'No') : '')
    html += row('Hospedaje', Array.isArray(d.hospedaje) ? d.hospedaje.join(', ') : d.hospedaje)
    html += row('Noches', d.noches)
    html += row('Crucero Destinos', (d.destinosCrucero || []).join(', '))
    html += row('Naviera', Array.isArray(d.naviera) ? d.naviera.join(', ') : d.naviera)
    html += row('Duración', Array.isArray(d.duracion) ? d.duracion.join(', ') : d.duracion)
    html += row('Cabina', d.cabina)
    html += row('Puertos', (d.puertos || []).join(', '))
    html += row('Hotel Destino', d.destinoHotel)
    html += row('Todo Incluido', d.todoIncluidoPref)
    html += row('Evento', d.eventoTipo)
    html += row('Evento Específico', d.eventoEspecifico)
    html += row('Presupuesto', d.presupuesto)
    html += row('Celebración', Array.isArray(d.celebracion) ? d.celebracion.join(', ') : d.celebracion)
    html += row('Notas', d.notasAdicionales)
    html += row('Fuente', Array.isArray(d.fuente) ? d.fuente.join(', ') : d.fuente)
    const dur = d.started_at ? calcFormDuration(d.started_at, sub.created_at) : ''
    html += row('Tiempo completar', dur)
    html += '</div>'
    const ph = (sub.contact_phone || '').replace(/[^0-9]/g, '')
    html += `<div style="margin-top:12px;display:flex;gap:8px;">`
    html += `<a href="https://wa.me/${ph}" target="_blank" class="btn btn-sm" style="background:var(--green);color:white;">WhatsApp</a>`
    if (!sub.lead_id) html += `<button class="btn btn-sm btn-primary" onclick="createLeadFromSubmission('${sub.id}')">Crear Lead en Pipeline</button>`
    else html += `<button class="btn btn-sm btn-secondary" onclick="openPanel('${sub.lead_id}')">Ver Lead</button>`
    html += `</div>`
    return html
}

function calcFormDuration(startedAt, createdAt) {
    const diff = new Date(createdAt) - new Date(startedAt)
    if (isNaN(diff) || diff < 0) return '—'
    const mins = Math.floor(diff / 60000)
    if (mins < 60) return `${mins} min`
    return `${Math.floor(mins/60)}h ${mins%60}m`
}

function setFormPeriod(p) {
    store.formPeriod = p
    document.querySelectorAll('#formPeriodTabs .period-tab').forEach(t => t.classList.remove('active'))
    document.querySelector(`#formPeriodTabs .period-tab[onclick="setFormPeriod('${p}')"]`)?.classList.add('active')
    renderFormularios()
}

function setFormStatusFilter(s) {
    store.formStatusFilter = s
    document.querySelectorAll('#formStatusTabs .period-tab').forEach(t => t.classList.remove('active'))
    document.querySelector(`#formStatusTabs .period-tab[onclick="setFormStatusFilter('${s}')"]`)?.classList.add('active')
    renderFormularios()
}

function sortFormTable(field) {
    const state = store || {}
    if (state.formSortField === field) state.formSortDir = state.formSortDir === 'asc' ? 'desc' : 'asc'
    else { state.formSortField = field; state.formSortDir = field === 'created_at' ? 'desc' : 'asc' }
    renderFormularios()
}

function toggleFormDetail(id) {
    const row = document.getElementById('formDetail_' + id)
    if (row) row.classList.toggle('open')
}

async function changeFormStatus(id, newStatus) {
    const { allFormSubmissions, pendingFormSubmissions } = store || {}
    await window.supabaseDB.updateFormSubmissionFields(id, { status: newStatus })
    const sub = allFormSubmissions.find(s => s.id === id)
    if (sub) sub.status = newStatus
    if (newStatus !== 'new') store.pendingFormSubmissions = pendingFormSubmissions.filter(s => s.id !== id)
    renderFormularios()
    window.toast('Estado actualizado', 'success')
}

function formToggleAll(checked) {
    const { formSelectedIds } = store || {}
    const filtered = filterFormSubmissions()
    if (checked) filtered.forEach(s => formSelectedIds.add(s.id))
    else formSelectedIds.clear()
    renderFormularios()
}

function formToggleRow(id, checked) {
    const { formSelectedIds } = store || {}
    if (checked) formSelectedIds.add(id); else formSelectedIds.delete(id)
    const bulkBtn = document.getElementById('formBulkActions')
    if (bulkBtn) { bulkBtn.style.display = formSelectedIds.size > 0 ? '' : 'none'; bulkBtn.textContent = `Acciones (${formSelectedIds.size})` }
}

function closeFormPopovers() {
    document.querySelectorAll('.form-popover').forEach(el => el.remove())
    if (_activePopoverBtn) { _activePopoverBtn.classList.remove('fp-active'); _activePopoverBtn = null }
}

function _positionPopover(pop, rect, align) {
    pop.style.visibility = 'hidden'
    document.body.appendChild(pop)
    const popH = pop.offsetHeight
    const spaceBelow = window.innerHeight - rect.bottom
    if (spaceBelow < popH + 8) {
        pop.style.bottom = (window.innerHeight - rect.top + 4) + 'px'
        pop.style.top = 'auto'
    } else {
        pop.style.top = (rect.bottom + 4) + 'px'
    }
    const popW = pop.offsetWidth
    if (align === 'right') {
        pop.style.right = Math.max(4, window.innerWidth - rect.right) + 'px'
    } else {
        const left = Math.min(rect.left, window.innerWidth - popW - 8)
        pop.style.left = Math.max(4, left) + 'px'
    }
    pop.style.visibility = ''
    setTimeout(() => document.addEventListener('click', closeFormPopovers, { once: true }), 10)
}

function showFormBulkMenu() {
    const { formSelectedIds } = store || {}
    if (formSelectedIds.size === 0) return
    const btn = document.getElementById('formBulkActions')
    if (_activePopoverBtn === btn) { closeFormPopovers(); return }
    closeFormPopovers()
    _activePopoverBtn = btn
    const rect = btn.getBoundingClientRect()
    const pop = document.createElement('div')
    pop.className = 'form-popover'
    pop.innerHTML = `<button class="form-popover-close" onclick="closeFormPopovers()">&times;</button>
        <div class="form-popover-item" onclick="execFormBulk('contacted')"><span class="fp-dot" style="background:var(--info);"></span>Marcar Contactado</div>
        <div class="form-popover-item" onclick="execFormBulk('converted')"><span class="fp-dot" style="background:var(--success);"></span>Marcar Convertido</div>
        <div class="form-popover-item" onclick="execFormBulk('archived')"><span class="fp-dot" style="background:var(--text-3);"></span>Archivar</div>
        <div class="form-popover-sep"></div>
        <div class="form-popover-item fp-danger" onclick="execFormBulkDelete()">Eliminar</div>`
    _positionPopover(pop, rect, 'left')
}

function execFormBulk(status) {
    const { allFormSubmissions, formSelectedIds } = store || {}
    closeFormPopovers()
    formSelectedIds.forEach(id => {
        window.supabaseDB.updateFormSubmissionFields(id, { status })
        const sub = allFormSubmissions.find(s => s.id === id)
        if (sub) sub.status = status
    })
    const cnt = formSelectedIds.size
    formSelectedIds.clear()
    renderFormularios()
    window.toast(`${cnt} solicitudes actualizadas`, 'success')
}

function execFormBulkDelete() {
    const { formSelectedIds } = store || {}
    closeFormPopovers()
    if (!confirm(`¿Eliminar ${formSelectedIds.size} solicitudes? Esta acción no se puede deshacer.`)) return
    let cnt = 0
    formSelectedIds.forEach(id => {
        window.supabaseDB.deleteFormSubmission(id)
        store.allFormSubmissions = store.allFormSubmissions.filter(s => s.id !== id)
        store.pendingFormSubmissions = store.pendingFormSubmissions.filter(s => s.id !== id)
        cnt++
    })
    formSelectedIds.clear()
    renderFormularios()
    window.updateFormBadge()
    window.toast(`${cnt} solicitudes eliminadas`, 'success')
}

function toggleFormRowMenu(event, id, hasLead) {
    event.stopPropagation()
    const btn = event.currentTarget
    if (_activePopoverBtn === btn) { closeFormPopovers(); return }
    closeFormPopovers()
    _activePopoverBtn = btn
    btn.classList.add('fp-active')
    const rect = btn.getBoundingClientRect()
    const pop = document.createElement('div')
    pop.className = 'form-popover'
    pop.innerHTML = `<button class="form-popover-close" onclick="event.stopPropagation();closeFormPopovers()">&times;</button>
        <div class="form-popover-item" ${hasLead ? 'style="opacity:0.35;pointer-events:none;"' : `onclick="closeFormPopovers();createLeadFromSubmission('${id}')"`}><span class="fp-dot" style="background:var(--purple-light);"></span>${hasLead ? 'Lead creado' : 'Crear Lead'}</div>
        <div class="form-popover-sep"></div>
        <div class="form-popover-item fp-danger" onclick="closeFormPopovers();deleteFormSubmissionById('${id}')">Eliminar</div>`
    _positionPopover(pop, rect, 'right')
}

async function deleteFormSubmissionById(id) {
    const { allFormSubmissions, formSelectedIds } = store || {}
    const sub = allFormSubmissions.find(s => s.id === id)
    const name = sub?.contact_name || 'esta solicitud'
    if (sub?.lead_id || sub?.status === 'converted') {
        if (!confirm(`La solicitud de "${name}" ya fue convertida a lead. ¿Eliminar de todas formas? El lead NO se elimina.`)) return
    } else {
        if (!confirm(`¿Eliminar la solicitud de "${name}"? Esta acción no se puede deshacer.`)) return
    }
    await window.supabaseDB.deleteFormSubmission(id)
    store.allFormSubmissions = allFormSubmissions.filter(s => s.id !== id)
    store.pendingFormSubmissions = store.pendingFormSubmissions.filter(s => s.id !== id)
    formSelectedIds.delete(id)
    renderFormularios()
    window.updateFormBadge()
    window.toast('Solicitud eliminada', 'success')
}

async function processNewSubmissions() {
    const { pendingFormSubmissions } = store || {}
    for (const sub of [...pendingFormSubmissions]) {
        if (sub.status === 'new' && !sub.lead_id) {
            try { await window.createLeadFromSubmission(sub.id) } catch (e) { console.error('Auto-create failed:', sub.id, e) }
        }
    }
}

async function pollNewSubmissions() {
    const { allFormSubmissions, pendingFormSubmissions, _processedSubmissionIds } = store || {}
    if (!window.supabaseDB.isConnected()) return
    const fresh = await window.supabaseDB.fetchFormSubmissions('new')
    if (!fresh || !fresh.length) return
    let found = 0
    for (const sub of fresh) {
        if (sub.lead_id) continue
        if (_processedSubmissionIds.has(sub.id)) continue
        // New submission not yet in memory — add it
        if (!allFormSubmissions.find(s => s.id === sub.id)) allFormSubmissions.unshift(sub)
        if (!pendingFormSubmissions.find(s => s.id === sub.id)) pendingFormSubmissions.push(sub)
        found++
        try { await window.createLeadFromSubmission(sub.id) } catch (e) { console.error('Poll auto-create failed:', sub.id, e) }
    }
    if (found > 0) {
        window.updateFormBadge()
        if (document.getElementById('formulariosView')?.classList.contains('active')) renderFormularios()
    }
}

async function createLeadFromSubmission(submissionId) {
    const { allFormSubmissions, leads, clients, team, _processedSubmissionIds, _recentSyncs } = store || {}
    if (_processedSubmissionIds.has(submissionId)) return
    _processedSubmissionIds.add(submissionId)
    const sub = allFormSubmissions.find(s => s.id === submissionId)
    if (!sub) return
    if (sub.status === 'converted' || sub.status === 'converting' || sub.lead_id) return

    // Server-side guard: atomically claim this submission to prevent
    // duplicates across multiple tabs, page reloads, or Realtime+poll races.
    // Uses UPDATE with status='new' filter — only ONE caller can succeed.
    if (sb) {
        try {
            const { data: claimed, error: claimErr } = await sb
                .from('form_submissions')
                .update({ status: 'converting' })
                .eq('id', submissionId)
                .eq('status', 'new')
                .select('id')
            if (claimErr) console.error('Claim submission error:', claimErr)
            if (!claimed || claimed.length === 0) {
                // Another process already claimed it — check if fully converted
                const { data: fresh } = await sb
                    .from('form_submissions')
                    .select('status, lead_id')
                    .eq('id', submissionId)
                    .single()
                if (fresh) { sub.status = fresh.status; sub.lead_id = fresh.lead_id }
                console.log('Submission already claimed by another process:', submissionId)
                return
            }
        } catch (e) { console.error('Claim check failed:', e) /* proceed — in-memory guards still active */ }
    }
    const d = sub.data || {}
    const tipos = d.tiposViaje || []
    let type = 'otro'
    const hasParques = tipos.includes('parques')
    const hasCrucero = tipos.includes('crucero')
    const hasHotel = tipos.includes('hotel')
    const hasEvento = tipos.includes('evento')
    if (hasParques && hasCrucero) type = 'parques_crucero'
    else if (hasParques) {
        if (d.parquesMarca === 'ambos') type = 'disney_universal'
        else if (d.parquesMarca === 'universal') type = 'universal'
        else type = 'disney'
    }
    else if (hasCrucero) type = 'crucero'
    else if (hasHotel) type = 'hotel'
    else if (hasEvento) type = 'evento'
    const phone = sub.contact_phone || ''
    const id = 'form_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5)
    const titular = (d.nombre || sub.contact_name || '').trim()
    // Determine platform/operator from form data
    let platform = null
    if (hasCrucero && d.naviera) {
        const lines = (Array.isArray(d.naviera) ? d.naviera : [d.naviera]).filter(l => l && l !== 'Recomiéndame')
        if (lines.length === 1) platform = lines[0]
        else if (lines.length > 1) platform = lines.join(' / ')
    }
    else if (hasParques) {
        if (d.parquesMarca === 'disney' || d.parquesMarca === 'ambos') platform = 'Disney'
        else if (d.parquesMarca === 'universal') platform = 'Universal'
    }
    const newLead = {
        id, titular, contacto: titular, phone, email: (d.email || sub.contact_email || '').trim(),
        type, platform, stage: 'formulario', source: 'Formulario Web',
        travelDate: d.fechaLlegada || (d.mesAproximado && d.anioAproximado ? (() => { const MESES_MAP = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']; const meses = Array.isArray(d.mesAproximado) ? d.mesAproximado : [d.mesAproximado]; const mi = MESES_MAP.findIndex(m => (meses[0] || '').toLowerCase().startsWith(m.toLowerCase())); return mi >= 0 ? `${d.anioAproximado}-${String(mi + 1).padStart(2, '0')}-15` : null })() : null) || (d.temporadaFlexible && d.anioAproximado ? (() => { const TM = {'Primer trimestre':1,'Segundo trimestre':4,'Tercer trimestre':7,'Cuarto trimestre':10}; const t = Array.isArray(d.temporadaFlexible) ? d.temporadaFlexible[0] : d.temporadaFlexible; const m = Object.entries(TM).find(([k]) => (t || '').includes(k)); return m ? `${d.anioAproximado}-${String(m[1]).padStart(2, '0')}-15` : null })() : null),
        travelEnd: d.fechaRegreso || null,
        destination: getFormTravelSummary(d), responsable: team[0]?.nombre || 'Sara',
        observaciones: `Solicitud web: ${tipos.map(t => FORM_TRIP_LABELS[t] || t).join(', ')}${d.mesAproximado ? '\nFechas tentativas: ' + (Array.isArray(d.mesAproximado) ? d.mesAproximado.join(', ') : d.mesAproximado) + ' ' + (d.anioAproximado || '') : ''}${d.temporadaFlexible ? '\nTemporada: ' + (Array.isArray(d.temporadaFlexible) ? d.temporadaFlexible.join(', ') : d.temporadaFlexible) + (d.anioAproximado ? ' ' + d.anioAproximado : '') : ''}${d.notasAdicionales ? '\n' + d.notasAdicionales : ''}`,
        formData: d, createdAt: sub.created_at,
        totalVenta: 0, commission: 0, commission70: 0, abono: 0, abonado: 0,
        progress: window.calcProgress('formulario'), viajeros: d.adultos ? (() => { const a = parseInt(d.adultos)||0, m = parseInt(d.menores)||0, ages = d.edadesMenores||[]; if (m===0) return `${a}A`; return `${a}A + ${m}M` + (ages.length ? ` (${ages.join(', ')})` : '') })() : null
    }
    const clientKey = phone || ('name:' + titular.toLowerCase())
    if (!clients[clientKey]) {
        clients[clientKey] = { titular, contacto: titular, phone, email: newLead.email, referido: null, canalAlerta: 'whatsapp', trips: [], createdAt: new Date() }
    }
    newLead.clientKey = clientKey
    clients[clientKey].trips.push(newLead)
    leads.push(newLead)
    window.addHistorial(newLead, 'creacion', `Lead creado desde formulario web — ${tipos.map(t => FORM_TRIP_LABELS[t] || t).join(', ')}`)
    sub.status = 'converted'
    sub.lead_id = newLead.id // Mark in-memory so button disables immediately
    // Pre-suppress Realtime self-echo using titular+phone key (before upsert returns UUID)
    const _selfEchoKey = `new_${(titular || '').toLowerCase()}_${phone || ''}`
    _recentSyncs.add(_selfEchoKey); setTimeout(() => _recentSyncs.delete(_selfEchoKey), 15000)
    window.supabaseDB.upsertLead(newLead).then(data => {
        if (data) {
            if (!newLead._supabaseId) {
                const oldId = newLead.id
                newLead._supabaseId = data.id
                newLead.id = data.id
                if (clients[clientKey]) {
                    const t = clients[clientKey].trips.find(t => t.id === oldId)
                    if (t) { t._supabaseId = data.id; t.id = data.id }
                }
                _recentSyncs.add(data.id); setTimeout(() => _recentSyncs.delete(data.id), 15000)
            }
            sub.lead_id = data.id
            window.supabaseDB.updateFormSubmissionStatus(submissionId, 'converted', data.id)
            window.renderAll() // Re-render cards with new UUID (single render after ID is stable)
        } else {
            window.supabaseDB.updateFormSubmissionStatus(submissionId, 'converted', null)
        }
    }).catch(err => {
        console.error('syncLead error:', err)
        window.supabaseDB.updateFormSubmissionStatus(submissionId, 'converted', null)
    })
    window.updateFormBadge() // Update badge immediately, defer full pipeline render to .then()
    renderFormularios()
    window.toast(`Lead creado: ${titular}`, 'success')
}

function exportFormSubmissions() {
    const filtered = filterFormSubmissions()
    if (!filtered.length) { window.toast('No hay datos para exportar', 'warning'); return }
    const rows = filtered.map(s => {
        const d = s.data || {}
        return {
            'Fecha': s.created_at, 'Nombre': s.contact_name || '', 'Teléfono': s.contact_phone || '',
            'Email': s.contact_email || '', 'Tipo Viaje': (d.tiposViaje || []).map(t => FORM_TRIP_LABELS[t] || t).join(', '),
            'Destino': getFormTravelSummary(d),
            'Fechas Viaje': d.fechaLlegada ? `${d.fechaLlegada} - ${d.fechaRegreso || ''}` : (d.mesAproximado ? `${Array.isArray(d.mesAproximado) ? d.mesAproximado.join(', ') : d.mesAproximado} ${d.anioAproximado || ''}`.trim() : (d.temporadaFlexible ? `${Array.isArray(d.temporadaFlexible) ? d.temporadaFlexible.join(', ') : d.temporadaFlexible}${d.anioAproximado ? ' ' + d.anioAproximado : ''}` : '')),
            'Adultos': d.adultos || '', 'Menores': d.menores || '', 'Presupuesto': d.presupuesto || '',
            'Fuente': Array.isArray(d.fuente) ? d.fuente.join(', ') : (d.fuente || ''),
            'Notas': d.notasAdicionales || '', 'Estado': s.status,
        }
    })
    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Formularios')
    XLSX.writeFile(wb, `formularios_${new Date().toISOString().slice(0, 10)}.xlsx`)
    window.toast('Excel exportado', 'success')
}

// ========== Register all functions on window ==========
Object.assign(window, {
    openHitosModal,
    renderHitosModalList,
    closeHitosModal,
    setDashScope,
    renderDashboard,
    setPeriod,
    getFormPhaseForStep,
    getFormPhaseIndex,
    refreshFormSubmissions,
    filterFormSubmissions,
    renderFormularios,
    renderFormStats,
    renderFormTripTypeChart,
    renderFormSourceChart,
    renderFormDestinationChart,
    renderFormConversionFunnel,
    renderFormStepFunnel,
    renderFormDropoffHotspots,
    renderFormTimePerPhase,
    renderFormDemandCalendar,
    renderFormTable,
    getFormTravelSummary,
    buildFormDetailHTML,
    calcFormDuration,
    setFormPeriod,
    setFormStatusFilter,
    sortFormTable,
    toggleFormDetail,
    changeFormStatus,
    formToggleAll,
    formToggleRow,
    closeFormPopovers,
    _positionPopover,
    showFormBulkMenu,
    execFormBulk,
    execFormBulkDelete,
    toggleFormRowMenu,
    deleteFormSubmissionById,
    processNewSubmissions,
    pollNewSubmissions,
    createLeadFromSubmission,
    exportFormSubmissions,
})
